import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';
import { useSelector } from 'react-redux';
import defaultIcon from '../../assets/image/company_default_icon.png';

const NotFound = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	console.log(user);
	return (
		<div className="not-found-container">
			<div className="error-code">
				<img
					src={
						user?.data?.organisation_logo !== '' &&
						user?.data?.organisation_logo !== null &&
						user?.data?.organisation_logo !== undefined
							? user?.data?.organisation_logo
							: defaultIcon
					}
					width={80}
					height={80}
					className="rounded-4"
					alt="logo"
				/>
			</div>
			<div className="error-message">{user?.organisation_name || ''}</div>
			<div className="back-home-link">
				<Link
					to={`/user/${suburl}/home`}
					className="link-text"
				>
					Back to Home
				</Link>
			</div>
		</div>
	);
};

export default NotFound;
